<style lang="scss" scoped>
@import "@/styles/variables.scss";
.tag {
    color: #fff;
    padding: 5px 25px;
    position: absolute;
    top: -15px;
    right: 30px;
    border-radius: $border-radius;
    &.offer {
        background: $secondary;
    }
    &.accepted,
    &.delivered,
    &.finalised,
    &.new {
        background: $primary;
    }
    &.onwaytopickup,
    &.nearpickup,
    &.arrivedpickup,
    &.loading,
    &.loaded,
    &.onwaytodelivery,
    &.neardelivery,
    &.arriveddelivery,
    &.unloading,
    &.unloaded,
    &.loaded,
    &.invoicereceived,
    &.paid {
        background: $green;
    }
    &.disabled {
        opacity: 0.6;
    }
}

.card-info-row {
    margin: 45px -7.5px 15px -7.5px;
    .card-info {
        border: 1px solid #e3eaee;
        display: inline;
        padding: 15px;
        margin: 0 7.5px;
        color: $secondary;
        white-space: nowrap;
    }
}
.line {
    border-right: 2px dashed $secondary;
    position: absolute;
    height: 70px;
    display: inline-block;
    left: 41px;
    top: 70px;
    height: calc(100% - 232px);
    z-index: 0;
}
.disabled-card {
    opacity: 0.8;
}
.zi-1{
    z-index: 1;
}
</style>

<template>
    <div>
        <a class="d-block" :class="{'disabled-card' : disabled}" @click="goToDetail">
            <box class="h-100" :clickable="!disabled">
                <template slot="content">
                    <div class="tag fs-12 text-uppercase" :class="labelClass" v-html="label"></div>
                    <span class="line"></span>
                    <div class="d-flex mb-30 zi-1">
                        <i-marker class="i-30 mr-15 mt-10 mb-auto svg-green"></i-marker>
                        <div>
                            <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ item.pickup_location.address.city }}</p>
                            <p class="mb-0 fs-12 font-weight-light" v-if="shipmenttype === 'my'">{{ item.pickup_location.address.formatted }}</p>
                            <p class="mb-0 fs-12 font-weight-light one-liner">{{ dateRange('pickup') }}</p>
                        </div>
                    </div>
                    <div class="d-flex zi-1">
                        <i-marker class="i-30 mr-15 my-auto"></i-marker>
                        <div>
                            <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ item.delivery_location.address.city }}</p>
                            <p class="mb-0 fs-12 font-weight-light" v-if="shipmenttype === 'my'">{{ item.delivery_location.address.formatted }}</p>
                            <p class="mb-0 fs-12 font-weight-light one-liner">{{ dateRange('delivery') }}</p>
                        </div>
                    </div>

                    <div v-if="myCardNoDriver" @click.stop="showAddDriverPopup = true" class="btn btn-gray-light btn-block mt-45">{{ $t('shipments.assigndriverbtn') }}</div>
                    <div class="card-info-row" v-else>
                        <div class="card-info">
                            <component class="i-30 mr-15" :is="'package-' + getPrefferedPackageType(item.packages)"></component> {{ item.packages.length }}x
                        </div>
                        <div class="card-info">
                            <i-watch class="i-30 mr-15"></i-watch>{{ routeDuration }}
                        </div>
                        <div class="card-info">
                            <i-distance class="i-30 mr-15"></i-distance>
                            <span class="my-auto">{{ Math.round((item.route.distance / 1000).toFixed(1)) }} km</span>
                        </div>
                    </div>
                </template>
            </box>

        </a>
        <popup-add-driver :show="showAddDriverPopup" :drivers="allFleetDrivers" :shipment="item" @close="showAddDriverPopup = false" @assigned="assignDriverToShipment"></popup-add-driver>
    </div>
</template>

<script>

import { PopupAddDriver } from "@/components/popups/_index";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "shipment-card",
    components: { PopupAddDriver },

    props: {
        /**
         * Object defining the shipment item
         * @type {Object}
         */
        item: {
            type: Object,
            default: () => {
                return {};
            }
        },

        /**
         * Object defining the offer
         * @type {Object}
         */
        offer: {
            type: Object,
            default: () => {
                return {};
            }
        },
        /**
         * String defining the shipment detail route
         * @type {String}
         */
        type: {
            type: String,
            default: "shipment-detail"
        },

        /**
         * String defining the shipment detail route
         * @type {String}
         */
        shipmenttype: {
            type: String,
            default: ""
        },

        /**
         * Boolean defining if a card is disabled or not
         * @type {Boolean}
         */
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showAddDriverPopup: false
        };
    },

    methods: {
        ...mapActions(["assignDriver"]),

        isEmpty(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) return false;
            }
            return true;
        },

        /* 
        | --------------
        | Navigate to the detail page of a shipment
        | --------------
        */
        goToDetail() {
            if (!this.disabled)
                this.$router.push({
                    name: this.type,
                    params: { shipmentId: this.item.id }
                });
        },

        /* 
        | --------------
        | Add a driver to a specific shipment
        | --------------
        */
        assignDriverToShipment(driver_id) {
            this.assignDriver({
                shipment_id: this.item.id,
                offer_id: this.item.offer_id,
                driver_id: driver_id
            });
        },

        getPrefferedPackageType(packages) {
            let type = packages[0].type;
            if (packages.length === 0) {
                return type;
            } else {
                let similar = true;
                packages.forEach(p => {
                    if (type !== p.type) similar = false;
                });
                if (similar) return type;
                else return 'custom'
            }
        },

        dateRange(puOrDo) {
            let string = this.$moment
                .unix(parseInt(this.item[`${puOrDo}_date_from`]))
                .tz(this.item[`${puOrDo}_date_timezone`])
                .format("DD MMMM");

            if (
                !this.isSameDay(
                    this.item[`${puOrDo}_date_from`],
                    this.item[`${puOrDo}_date_till`],
                    this.item[`${puOrDo}_date_timezone`]
                )
            ) {
                string +=
                    " -> " +
                    this.$moment
                        .unix(parseInt(this.item[`${puOrDo}_date_till`]))
                        .tz(this.item[`${puOrDo}_date_timezone`])
                        .format("DD MMMM");
            }

            string += " | ";

            if (
                this.checkTime(
                    this.item[`${puOrDo}_date_from`],
                    this.item[`${puOrDo}_date_till`],
                    this.item[`${puOrDo}_date_timezone`]
                ) === "arrangement"
            ) {
                string += this.$t("shipments.times.arrangement");
            } else {
                string += this.$moment
                    .unix(parseInt(this.item[`${puOrDo}_date_from`]))
                    .tz(this.item[`${puOrDo}_date_timezone`])
                    .format("HH:mm");
                string += " -> ";
                string += this.$moment
                    .unix(parseInt(this.item[`${puOrDo}_date_till`]))
                    .tz(this.item[`${puOrDo}_date_timezone`])
                    .format("HH:mm");
            }

            return string;
        }
    },

    computed: {
        ...mapGetters(["allFleetDrivers"]),
        routeDuration() {
            return this.$moment("2015-01-01")
                .startOf("day")
                .seconds(this.item.route.duration)
                .format("H:mm");
        },

        noDriverAssigned() {
            return !this.isEmpty(this.offer) && !this.offer.assigned;
        },

        myCardNoDriver() {
            return this.shipmenttype === "my" && this.noDriverAssigned;
        },

        label() {
            if (this.noDriverAssigned) {
                let label = "";

                if (this.shipmenttype === "offer") {
                    label += this.$t("states." + this.offer.shipment_status);
                    label += "<br>";
                }

                label += "€ " + this.offer.cost_breakdown_driver.route.toFixed(2);
                return label;
            } else {
                return this.$t("states." + this.currentState.state);
            }
        },

        labelClass() {
            if (this.noDriverAssigned && !this.item.offer_id) {
                return "offer";
            } else {
                return this.currentState.state;
            }
        },

        currentState() {
            return this.orderedStates.slice(-1)[0];
        },

        orderedStates() {
            let ordered = [];

            if (this.item.hasOwnProperty("states")) {
                ordered = this.item.states.slice().reverse();

                if (
                    this.item.accepted_offer.driver_invoice_received !==
                    "0000-00-00"
                ) {
                    ordered.push({
                        state: "invoicereceived",
                        created_at: this.item.accepted_offer
                            .driver_invoice_received
                    });
                }

                if (
                    this.item.accepted_offer.driver_invoice_paid !==
                    "0000-00-00"
                ) {
                    ordered.push({
                        state: "paid",
                        created_at: this.item.accepted_offer.driver_invoice_paid
                    });
                }
            } else {
                ordered.push(this.item.current_state);
            }

            return ordered;
        }
    }
};
</script>
